// extracted by mini-css-extract-plugin
export default {"gratuity-header":"GratuityReport_gratuity-header__BAmP9","divider":"GratuityReport_divider__6aajA"};